// removed by extract-text-webpack-plugin
module.exports = {"ToggleButton":"ToggleButton__ToggleButton__3klNA","ToggleButtton":"ToggleButton__ToggleButtton__1xK_W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/ToggleButton/ToggleButton.css
// module id = 79
// module chunks = 3